/* eslint-disable react/prop-types */
import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { Tab, Container } from "semantic-ui-react";
import Constants from "../utilities/Constants";
import TsExpertConfigChannel1 from "./ts-expert-configs/TsExpertConfigChannel1";
import TsExpertConfigChannel2 from "./ts-expert-configs/TsExpertConfigChannel2";
import TsExpertConfigChannel3 from "./ts-expert-configs/TsExpertConfigChannel3";
import TsExpertConfigChannel4 from "./ts-expert-configs/TsExpertConfigChannel4";
import Strings from "../utilities/StringSelector";
class TsExpertConfig extends Component {

  // Verifies if the user has the credentials to be logged in
  // If he does he is re-directed to the configuration page
  // If he doesn't he is re-directed to the login page
  isUserLoggedIn = () => {
    if (sessionStorage.auth !== Constants.AUTH_STR) {
      this.props.history.push({ pathname: "/login" });
    }
  }

  componentDidMount() {
    this.isUserLoggedIn();
  }

  // ----------------- Lifecycle Methods ----------------
  render() {
    const panes = [
      {
        menuItem: { key: "channel-1", content: Strings.CHANNEL_1 },
        render: () => <Tab.Pane> <TsExpertConfigChannel1 channel={1} /> </Tab.Pane>
      },
      {
        menuItem: { key: "channel-2", content: Strings.CHANNEL_2 },
        render: () => <Tab.Pane> <TsExpertConfigChannel2 channel={2} /> </Tab.Pane>
      },
      {
        menuItem: { key: "channel-3", content: Strings.CHANNEL_3 },
        render: () => <Tab.Pane> <TsExpertConfigChannel3 channel={3} /> </Tab.Pane>
      },
      {
        menuItem: { key: "channel-4", content: Strings.CHANNEL_4 },
        render: () => <Tab.Pane> <TsExpertConfigChannel4 channel={4} /> </Tab.Pane>
      },
    ];

    return (
      <Container>
        <Tab panes={panes} renderActiveOnly={true} />
      </Container>
    );
  }
}
export default withRouter(TsExpertConfig);
